/* eslint-disable react/prop-types */
import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  defaults
} from 'chart.js'
import { Line } from 'react-chartjs-2'

defaults.font.family = 'Fira Sans'

const fechas = {
  '15-Feb': { pos: 43, text: ['Inicio votaciones en pleno', 'de informes de comisiones'] },
  '14-May': { pos: 131, text: ['Última votación del pleno', 'de informe de comisiones'] },
  '4-Jul': { pos: 182, text: ['Entrega propuesta', 'nueva constitución'] },
  '5-Jul': { pos: 183, text: ['Carta del ex presidente', 'R. Lagos'] },
  '11-Jul': { pos: 189, text: ['', 'Anuncio Bono Invierno'] },
  '15-Jul': { pos: 193, text: ['Declaraciones Presidente', 'Gabriel Boric'] },
  '23-Jul': { pos: 201, text: ['Carta ex Presidenta', 'M. Bachelet'] }
}

const pluginImage = {
  id: 'customImage',
  beforeDraw: (chart) => {
    const image = chart.config._config.options.img_decidechile

    const {
      ctx
    } = chart

    ctx.save()
    ctx.globalAlpha = 0.6
    if (image.complete) {
      const ctx = chart.ctx
      const {
        top,
        left
      } = chart.chartArea
      let imageWidth = 0.2 * image.naturalWidth
      let imageHeight = 0.2 * image.naturalHeight
      if (chart.width < 800) {
        imageWidth = 0.7 * imageWidth
        imageHeight = 0.7 * imageHeight
      }

      const x = left - imageWidth + 200
      const y = top - imageHeight + 100

      ctx.drawImage(image, x, y, imageWidth, imageHeight)
    } else {
      image.onload = () => chart.draw()
    }
    ctx.restore()
  }
}

const vlinePlugin = {
  id: 'vline',
  afterInit: (chart) => {
    chart.corsair = {
      x: 0,
      y: 0
    }
  },

  afterEvent: (chart, evt) => {
    const {
      chartArea: {
        top,
        bottom,
        left,
        right
      }
    } = chart
    const {
      x,
      y
    } = evt.event
    if (x < left || x > right || y < top || y > bottom) {
      chart.corsair = {
        x,
        y,
        draw: false
      }
      chart.draw()
      return
    }

    chart.corsair = {
      x,
      y,
      draw: true
    }

    chart.draw()
  },
  afterDatasetsDraw: chart => {
    const {
      x
    } = chart.corsair

    const nElements = 7 * (chart.config._config.data.datasets[0].data.length - 1)
    const chartWidth = chart.chartArea.width
    const chartLeft = chart.chartArea.left
    const widthDiv = chartWidth / nElements

    Object.keys(fechas).forEach(key => {
      const xFecha = widthDiv * fechas[key].pos + chartLeft
      const yAxis = chart.scales.y
      const ctx = chart.ctx
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(xFecha, yAxis.top)
      ctx.lineTo(xFecha, yAxis.bottom)
      ctx.setLineDash([5, 5])
      ctx.lineWidth = 1
      if (Math.abs(x - xFecha) <= 2) {
        ctx.lineWidth = 3
        let defTop = -5
        let defJump = 10
        if (chart.width < 800) {
          ctx.font = 'bold 8px Fira Sans'
          defTop = -3
          defJump = 7
        } else {
          ctx.font = 'bold 12px Fira Sans'
        }
        if (x > 0.5 * chartWidth) {
          ctx.direction = 'rtl'
        }
        ctx.lineWidth = 2
        fechas[key].text.forEach((el, idx) => ctx.fillText(`${el}`, xFecha, defTop + yAxis.top + defJump * (idx - 1)))
        ctx.font = '12px Fira Sans'
        ctx.fillText(key, xFecha, yAxis.top - 25)
      }
      ctx.strokeStyle = 'rgba(41, 84, 223, 0.4)'
      ctx.stroke()
      ctx.restore()
    })
  }
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  pluginImage,
  vlinePlugin
)

export function MediosChart ({ chartData, options }) {
  return (
      <div className = "chart-container">
        <Line options={options} data={chartData} id = "mediosChart"/>
      </div>)
}
